import createVueApp from '@/common/create_app'

Styxie.Initializers.UsersInvitations = {
  edit: async(props) => {
    const { default: InvitationsEdit } = await import('@/vue_widgets/users/invitations/edit/index.vue')
    createVueApp(InvitationsEdit, { props, layout: null })
  }
}
